<template>
   
    <!-- <div class="cause_wrap"> -->

  

        <div  class="cause_box" :style="'height:'+screenHeight*0.8+'px' ">
            <el-aside width="180px" >
                <el-menu >
                    <el-menu-item v-for="(item,index) in civil_list"  @click="SearchCause(item,index)"  :key="index">{{item.name}}</el-menu-item>
                </el-menu>            
            </el-aside>


            <div class="rightside">
                <div class="Head">
                    <div class="searchRow">
                        <el-input placeholder="输入案由进行查询，不少于两个字" v-model="inputValue" style="width:70%">
                        <el-select v-model="casetype" @change="ChangeCaseType" slot="prepend" placeholder="请选择1" style="width:90px">
                            <el-option label="民事" value="1"></el-option>
                            <el-option label="刑事" value="2"></el-option>                 
                        </el-select>
                            <el-button slot="append" type="primary" icon="el-icon-search" @click="SearchEvent" >搜索</el-button>
                        </el-input>   

                        <el-button plain style="margin-left:30px" @click="resetPage">重置搜索</el-button>
                    </div> 

                </div> 

                <div class="bottom">
                    <div class='separate'  >  释义</div>
                    <div class='content' v-html="nodes_expl"> </div>  
                    
                    <div class='separate'>  
                        法律适用
                    </div>
                    <div class='content' v-html="nodes_laws"> </div> 
                    <div class='separate'>  
                        管辖
                    </div>
                    <div class='content' v-html="nodes_jus"> </div> 
                    <div class='separate'>  
                        注意事项 
                    </div>
                    <div class='content' v-html="nodes_tips"> </div> 
                        

                </div>


            </div>

       
        </div>
    <!-- </div> -->
     
</template>

<script>

function Json2arr(data){
    let result = data;
    let len = result.length;
    let resu = new Array;
    for (var i = 0; i < len; i++) {
        resu[i] = JSON.parse(result[i]);
 
    }
    result = resu;
    return result;
}

// var page=0
 import { IncUseNumber } from '@/assets/js/cal/cal'; 

export default {
		name: 'cause',
		// props: {
		// 	pageId: String
        // },
        data() {
			return { 
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,

                casetype:'1',
                inputValue:'',
                civil_list: [ {name:'民事',id:0,stage:0}, {name:'商事',id:1,stage:0}, {name:'知识产权',id:2,stage:0}, {name:'涉外商事',id:3,stage:0}, {name:'房地产',id:4,stage:0}, {name:'劳动争议',id:5,stage:0}, {name:'企业破产清算',id:6,stage:0}],
                civil_sub:[
       [{name:"不当得利纠纷",id:37,stage:1}, {name:"担保物权纠纷",id:38,stage:1},{name: "督促程序案件",id:39,stage:1} ,{name:"公示催告程序案件",id:40,stage:1} ,{name:"合同纠纷",id:41,stage:1}, {name:"婚姻家庭纠纷",id:42,stage:1}, {name:"继承纠纷",id:43,stage:1}, {name:"监护权特别程序案件",id:44,stage:1}, {name:"侵权责任纠纷",id:45,stage:1}, {name:"人格权纠纷",id:46,stage:1}, {name:"认定财产无主案件",id:47,stage:1}, {name:"认定公民无民事行为能力、限制民事行为能力案件", id:48,stage:1},{name:"申请保全案件",id:49,stage:1}, {name:"所有权纠纷",id:50,stage:1}, {name:"无因管理纠纷",id:51,stage:1}, {name:"物权保护纠纷",id:52,stage:1}, {name:"宣告失踪、宣告死亡案件",id:53,stage:1}, {name:"选民资格案件",id:54,stage:1}, {name:"用益物权纠纷",id:55,stage:1}, {name:"占有保护纠纷",id:56,stage:1}, {name:"执行异议之诉",id:57,stage:1}, {name:"仲裁程序案件",id:58,stage:1}],
        [{name:'保险纠纷',id:59,stage:1}, {name:'不正当竞争',id:60,stage:1}, {name:'担保物权纠纷',id:61,stage:1},{name: '督促程序案件',id:62,stage:1}, {name:'公示催告程序案件',id:63,stage:1}, {name:'海事海商纠纷',id:64,stage:1}, {name:'海事诉讼特别程序案件',id:65,stage:1}, {name:'合伙企业纠纷',id:66,stage:1}, {name:'合同纠纷',id:67,stage:1}, {name:'垄断纠纷',id:68,stage:1}, {name:'票据纠纷',id:69,stage:1}, {name:'期货交易纠纷',id:70,stage:1},{name: '申请保全案件',id:71,stage:1}, {name:'申请承人与执行法院判决、仲裁裁决案件',id:72,stage:1}, {name:'信托纠纷',id:73,stage:1}, {name:'信用证纠纷',id:74,stage:1}, {name:'与公司有关的纠纷',id:75,stage:1}, {name:'与企业有关的纠纷',id:76,stage:1}, {name:'占有保护纠纷',id:77,stage:1}, {name:'证券纠纷',id:78,stage:1}, {name:'执行异议之诉',id:79,stage:1}, {name:'仲裁程序案件',id:80,stage:1}],
        [{name:'申请承认与执行法院判决、仲裁裁决案件',id:81,stage:1}, {name:'知识产权合同纠纷',id:82,stage:1}, {name:'知识产权权属、侵权纠纷',id:83,stage:1}, {name:'执行异议之诉',id:84,stage:1}],
        [{name:'申请承认与执行法院判决、仲裁裁决案件',id:85,stage:1},{name:'执行异议之诉',id:86,stage:1}],
        [{name:'不动产登记纠纷',id:87,stage:1}, {name:'担保物权纠纷', id:88,stage:1},{name:'合同纠纷',id:89,stage:1}, {name:'所有权纠纷',id:90,stage:1}, {name:'物权保护纠纷',id:91,stage:1}, {name:'用益物权纠纷',id:92,stage:1}, {name:'执行异议之诉',id:93,stage:1}],
        [{name:'劳动争议',id:94,stage:1}, {name:'人事争议',id:95,stage:1}, {name:'执行异议之诉',id:96,stage:1}],
        [{name:'与公司有关的纠纷',id:97,stage:1}, {name:'与破产有关的纠纷',id:98,stage:1}, {name:'执行异议之诉',id:99,stage:1}]
       ],
                catalog:[ {name:'民事',id:0}, {name:'商事',id:1}, {name:'知识产权',id:2}, {name:'涉外商事',id:3}, {name:'房地产',id:4}, {name:'劳动争议',id:5}, {name:'企业破产清算',id:6}],
                stage:'',

                detail: '',
                name: '',
                nodes_expl: '',
                nodes_jus: '',
                nodes_laws: '',
                nodes_tips: '',
                id:'',
                islastpage:'no',
                list:[],
                parent_num:'',
                issub:'no',

                wxappcode:false,
                page:0
              
            }
        },

        mounted(){
            IncUseNumber('lawlib_causedetail')
        },

        methods:{
             ChooseParam(id){
                    window.console.log(id)
                    if(id=='0'){
                        this.civil_list=this.civil_sub[0]
                    }else if(id=='1'){
                        this.civil_list=this.civil_sub[1]
                    }else if(id=='2'){
                        this.civil_list=this.civil_sub[2]
                    } else if(id=='3'){
                        this.civil_list=this.civil_sub[3]
                    } else if(id=='4'){
                        this.civil_list=this.civil_sub[4]
                    }else if(id=='5'){
                        this.civil_list=this.civil_sub[5]
                    }else if(id=='6'){
                        this.civil_list=this.civil_sub[6]
                    }

                    // console.log(e.target.id)
                },
                SearchCause(item,index){
                    window.console.log('item=',item)
                    window.console.log('index=',index)
                    var _this=this
                    var stage=item.stage
                    var id=item.id
                    var issub=item.issub || ''
                    window.console.log(issub)
                    window.console.log(stage,id)
                    if(this.casetype=='1'){
                        if(stage==0){
                        this.ChooseParam(id)
                        }else if(stage==1){
                            this.getsub2(id)
                        }else if(item.explains){
                            // this.detail
                            this.detail=this.civil_list[index].detail
                            this.name= this.civil_list[index].name
                            this.nodes_expl= this.civil_list[index].explains
                            this.nodes_jus= this.civil_list[index].jurisdiction
                            this.nodes_laws= this.civil_list[index].laws
                            this.nodes_tips= this.civil_list[index].tips
                            this.id= this.civil_list[index].id
                        }

                    }

                    if(this.casetype=='2'){
                        if(stage==0){
                            if(!issub || issub!='yes'){
                               
                                let data= { 
                                    factor: { num: id },
                                    whattodo: 'complex_retrive',
                                    field: '*',
                                    group: '',
                                    limit: 'LIMIT 1',
                                    order: 'ORDER BY id ASC',
                                    table_name: 'crim_anal',
                                    openid: 'o2cfM4rDLXSGkR2wKOi9XNkpgbyw',
                                    TOKEN:"UDRrNGtCWEhYd3hoYVkyNC9uaWxrNnMzZ1JwZk9uZDJ4MFpFa1JCUWRFND0oeXlqbGF3KzExbGF3LmNuKdAFxJENtjj8BdwORdMeXjQoeXlqbGF3KzExbGF3LmNuKTE1NjEyMDY4NDA="

                                }
                                this.axios.post('https://www.lawtip.cn/webservice/clientAPI/test_API_forweb.php',data
                                ).then(function (res) {

                                    window.console.log('179 res=',res);
                                    window.console.log(res.data)
                                    if (res.data != 'cannotreaddb' && res.data != 'nosuchuser') {
                                        let result = Json2arr(res.data);
                                        if (result[0].page == '1') {
                                            _this.islastpage='yes'
                                            // that.setData({ islastpage: 'yes' })
                                        }
                                        window.console.log(result[0].page,_this.islastpage)
                                        result = result[0].json_str
                                        // console.log(result)
                                        window.console.log(typeof (result))
                                        result = "{" + result + "}"
                                        result = JSON.parse(result)
                                        window.console.log(typeof (result))
                                        window.console.log(result)
                                        let obj = result.data.list;
                                        
                                        window.console.log(obj)
                                       
                                        let item=_this.list
                                        item = item.concat(obj);
                                        _this.civil_list=item
                                        // that.setData({
                                        //     list: item,
                                        // })
                                        _this.page++
                                    

                                    
                            
                                    }
                                }).catch(function (error) {
                                    window.console.log(error);
                                });


                            }  else if(issub=='yes' ){
                                _this.parent_num=id
                                let data= { 
                                    factor: { num: id },
                                    whattodo: 'complex_retrive',
                                    field: 'sec_name',
                                    group: '',
                                    limit: '',
                                    order: 'ORDER BY id ASC',
                                    table_name: 'crim_anal',
                                    openid: 'o2cfM4rDLXSGkR2wKOi9XNkpgbyw',
                                    TOKEN:"UDRrNGtCWEhYd3hoYVkyNC9uaWxrNnMzZ1JwZk9uZDJ4MFpFa1JCUWRFND0oeXlqbGF3KzExbGF3LmNuKdAFxJENtjj8BdwORdMeXjQoeXlqbGF3KzExbGF3LmNuKTE1NjEyMDY4NDA="

                                }
                                this.axios.post('https://www.lawtip.cn/webservice/clientAPI/test_API_forweb.php',data
                                ).then(function (res) {
                                    let result = Json2arr(res.data);
                                    var arr=[]
                                    for(let i in result){
                                        arr.push(
                                            {name:result[i].sec_name,id:i,stage:1,issub:'yes'}
                                        )
                                    }
                                    _this.civil_list=arr
                                    _this.issub='yes'

                                    // that.setData({
                                    //     list: result,
                                    //     issub:'yes'
                                    // })


                                }).catch(function (error) {
                                    window.console.log(error);
                                })




                            }


                        }else if(stage==1){
                            if(_this.casetype=='1'  || (_this.casetype=='2' && (issub=='no' || !issub) ) ){
                                this.getsub2(id)
                            }
                            else if(_this.casetype=='2' && issub=='yes'){
                                  
                                    let data= { 
                                        factor:  { num: _this.parent_num, subnum: id },
                                        whattodo: 'complex_retrive',
                                        field: '*',
                                        group: '',
                                        limit: '',
                                        order: '',
                                        table_name: 'crim_anal',
                                        openid: 'o2cfM4rDLXSGkR2wKOi9XNkpgbyw',
                                        TOKEN:"UDRrNGtCWEhYd3hoYVkyNC9uaWxrNnMzZ1JwZk9uZDJ4MFpFa1JCUWRFND0oeXlqbGF3KzExbGF3LmNuKdAFxJENtjj8BdwORdMeXjQoeXlqbGF3KzExbGF3LmNuKTE1NjEyMDY4NDA="

                                    }
                                    this.axios.post('https://www.lawtip.cn/webservice/clientAPI/test_API_forweb.php',data
                                    ).then(function (res) {
                                        let result = Json2arr(res.data);
                                         result = result[0].json_str
                                        window.console.log(typeof (result))
                                        // result = "{" + result + "}"
                                        if(result[0]!='{'){
                                            result = "{" + result + "}"
                                        }

                                        result = JSON.parse(result)
                                        window.console.log(typeof (result))
                                        window.console.log(result)
                                        let obj = result.data.list;
                                        window.console.log(obj)

                                        _this.civil_list=obj
                                        // that.setData({
                                        //     list: obj,

                                        // })

                                    }).catch(function (error) {
                                         window.console.log(error);
                                    })
                                

                            }
                           
                        }else if(item.explains){
                            // this.detail
                            this.detail=this.civil_list[index].detail
                            this.name= this.civil_list[index].name
                            this.nodes_expl= this.civil_list[index].explains
                            this.nodes_jus= this.civil_list[index].jurisdiction
                            this.nodes_laws= this.civil_list[index].laws
                            this.nodes_tips= this.civil_list[index].tips
                            this.id= this.civil_list[index].id
                        }
                    }
                    


                },
                getsub2(id){
                    var _this=this
                    var data= { 
                        factor: { id: id },
                        whattodo: 'complex_retrive',
                        field: '*',
                        group: '',
                        limit: '',
                        order: '',
                        table_name: 'civil_anal',
                        openid: 'o2cfM4rDLXSGkR2wKOi9XNkpgbyw',
                        TOKEN:"UDRrNGtCWEhYd3hoYVkyNC9uaWxrNnMzZ1JwZk9uZDJ4MFpFa1JCUWRFND0oeXlqbGF3KzExbGF3LmNuKdAFxJENtjj8BdwORdMeXjQoeXlqbGF3KzExbGF3LmNuKTE1NjEyMDY4NDA="

                    }
                    this.axios.post('https://www.lawtip.cn/webservice/clientAPI/test_API_forweb.php',data
                    ).then(function (res) {

                        window.console.log('179 res=',res);
                        window.console.log(res.data)
                        if (res.data != 'cannotreaddb' && res.data != 'nosuchuser') {
                            let result = Json2arr(res.data);
                            result = result[0].json_str
                            window.console.log(typeof (result))
                            // result = "{" + result + "}"
                            if (result[0] != '{') {
                                result = "{" + result + "}"
                            }

                            result = JSON.parse(result)
                            window.console.log(typeof (result))
                            window.console.log(result)
                            let obj = result.data.list;
                            window.console.log(obj)
                            
                            _this.civil_list=obj

                            // that.setData({
                            //     list: obj,

                            // })

                        
                  
                        }
                    }).catch(function (error) {
                        window.console.log(error);
                    });

                },

                SearchEvent(){
                    var _this=this,tablename
                    if(this.casetype=='1'){
                        tablename='civil_case'
                    }else if(this.casetype=='2'){
                        tablename='crim_case'
                    }

                    var data= { 
                        factor: 'name LIKE ' + "'%" + _this.inputValue + "%'",
                        whattodo: 'fuzzy_query',
                        field: '*',
                        group: '',
                        limit: '',
                        order: '',
                        table_name: tablename,
                        openid: 'o2cfM4rDLXSGkR2wKOi9XNkpgbyw',
                        TOKEN:"UDRrNGtCWEhYd3hoYVkyNC9uaWxrNnMzZ1JwZk9uZDJ4MFpFa1JCUWRFND0oeXlqbGF3KzExbGF3LmNuKdAFxJENtjj8BdwORdMeXjQoeXlqbGF3KzExbGF3LmNuKTE1NjEyMDY4NDA="

                    }

                    this.axios.post('https://www.lawtip.cn/webservice/clientAPI/test_API_forweb.php',data
                    ).then(function (res) {
                        window.console.log(res.data)
                        if(res.data=='nosuchuser'){
                            _this.$alert('没有查询到结果噢',  {
                            confirmButtonText: '确定',
                           
                            });
                        }
                        if (res.data != 'cannotreaddb' && res.data != 'nosuchuser') {
                            let result = Json2arr(res.data);
                            window.console.log(result)
                            // that.setData({
                            //     list: result,
                            // })
                            _this.civil_list=result
                        }

                    }).catch(function (error) {
                        window.console.log(error);
                    });



                },

                ChangeCaseType(){
                    window.console.log('改变casetype')
                    if(this.casetype=='2'){
                        this.civil_list= [{ name: '危害国家安全罪', id: 0,stage:0 }, { name: '危害公共安全罪', id: 1,stage:0 }, { name: '侵犯公民人身权利，民主权利罪', id: 2,stage:0 }, { name: '侵犯财产罪', id:3,stage: 0 }, { name: '危害国防利益罪', id: 4,stage:0 }, { name: '军人违反职责罪', id: 5,stage:0 }, { name: '破坏社会主义市场经济秩序罪', id: 6,stage:0, issub: 'yes' }, { name: '妨害社会管理秩序罪', id: 7,stage:0, issub: 'yes' }, { name: '贪污贿赂罪', id: 8,stage:0 }, { name: '渎职罪', id: 9,stage:0 }
        ]
                        
                    }
                    if(this.casetype=='1'){
                        this.civil_list= [ {name:'民事',id:0,stage:0}, {name:'商事',id:1,stage:0}, {name:'知识产权',id:2,stage:0}, {name:'涉外商事',id:3,stage:0}, {name:'房地产',id:4,stage:0}, {name:'劳动争议',id:5,stage:0}, {name:'企业破产清算',id:6,stage:0}]
                    }

                },


                resetPage(){
                    this.inputValue=''
                    // this.create()
                    this.civil_list = [ {name:'民事',id:0,stage:0}, {name:'商事',id:1,stage:0}, {name:'知识产权',id:2,stage:0}, {name:'涉外商事',id:3,stage:0}, {name:'房地产',id:4,stage:0}, {name:'劳动争议',id:5,stage:0}, {name:'企业破产清算',id:6,stage:0}]
                    this.casetype='1'
                }

        }

       


    }
</script>

<style scoped>

    /* .el-select .el-input {
        width: 100px;
    } */
    /* .input-with-select .el-input-group__prepend {
        background-color: #fff;
         
    } */
    /* .cause_wrap{
        display: flex;
        flex-direction: column;
        width: 100%;
        border:1px solid #ad1d89;
        min-height:480px;
    } */
    .searchRow{
        width:90%;
        /* border:1px solid #071018; */
        display: flex;
        flex-direction: row;
        

    }

    .cause_box{
        display: flex;
        flex-direction: row;
        width: 100%;
        /* border:1px solid #531143; */

    }
    .input-with-select {
        height: 100%;
    }
    .el-select{
        width:80px;
        /* border:1px solid #c41cc4; */
        overflow: hidden;
        line-height: 100%;

    }
    .Head{
        height:60px;
        padding-left:15px;
        display: flex;
        flex-direction: row;
        align-items:center;
        /* justify-content: center; */
    }

    .rightside{
        padding: 4px;
     
        width: 100%;
        /* border:1px solid #071018; */
        /* height:550px; */
        height: 100%;
    }

    .bottom{
        height: 100%;
        width:100%;

        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        /* border:1px solid #b6db10; */
        /* overflow-y:scroll; */
        padding: 2px;
    }
    
    .el-aside {
        /* background-color: #D3DCE6; */
        background-color: #fff;
        color: #333;
        text-align: center;
        line-height: 200px;
        /* height: 550px; */
        height: 100%;
        /* border-top:1px solid #185c9c; */
        border-right:1px solid #185c9c;
        
    }
    
    .el-main {
        padding-top: 5px;
        border-top:1px solid #185c9c;
        background-color: #fff;
        color: #333;
        height: 550px;
        /* border:1px solid #47bb2a; */

        /* text-align: center; */
        /* line-height: 160px; */
        /* height: auto; */
    }
    
    body > .el-container {
        margin-bottom: 40px;
    }
    
    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
        line-height: 260px;
    }
    
    .el-container:nth-child(7) .el-aside {
        line-height: 320px;
    }


    /* .wrap{
    width:90%;
    margin:auto;
    height: auto;
    border:1px solid #185c9c;
    } */



    .separate{
        width:100%;
        height: 35px;
        padding-left: 15px;
        color: #1296db;
        line-height: 35px;
        font-weight: bold;
        font-size:18px;
        /* border:1px solid #185c9c; */
        /* display: inline-block; */
        text-align: left;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        margin-bottom: 0;
        background-color: #E4E7ED;

    }

    /* .separate image{
        width:10px;
        height: 10px;
        border: 1rpx solid #333;
    } */

    .separate p{
        margin-left: 10px;
        height: 32px;
        width:30%;
        border: 1px solid #333; 
    }
    .bluespot{
        width:20px;
        height: 20px;
        border: 1px solid #333;
    }

    .content{
        padding: 10px;
        background-color: #ffffff;
        width: 99%;
        /* margin: 10px; */
        line-height: 28px;
        height: auto;
        text-align: left;
        margin-top:5px;

    }

    .para_tag_box{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        /* padding-top:10px;
        padding-bottom: 10px; */
        border: 1px solid #333;
        line-height: 35px;
        
    }

    .para_tag{
        /* background-color: #409eff; */
        display: flex;
        width: auto;
        margin-left: 15px;
        /* border: 1px solid #333; */
        /* line-height: 45px; */
        padding:10px 15px 10px 15px;
    }

    /* .para_tag span{
        background-color: #8fc4f8;
    } */


    .para_tag_image{
        width:15px;
        height: 15px;
        /* opacity: 0.7; */
        margin-left: 5px;

    }
    .SearchBox{
        display: flex;
        flex-direction: column;
        width: 75%;
        /* border: 1px solid #333;  */
        margin-top:auto;
        margin-bottom:auto;
        padding: auto;
        /* line-height: 60px; */
        height: 90%;
        padding: auto;
    }
   
</style>
